/*
 * Copyright (c) 2024. Amazon.com, Inc. or its affiliates. All rights reserved.
 */
import { jsx } from '@amzn/shiv'
import { el, hide, show } from '@amzn/shiv'

// Can be approximate, will remove and GC the child after the transition
const FADE_OUT_DURATION = 1

export function toast(message: string | HTMLElement, time = 3) {
    const toastContainer = el('#toastContainer')
    const messages = el('#toastContainer > .messages')
    const div = typeof message === 'string' ? <div className="message">{message}</div> : message
    messages.appendChild(div)
    show(toastContainer)

    setTimeout(() => {
        div.classList.add('hide')
        setTimeout(() => {
            messages.removeChild(div)
        }, FADE_OUT_DURATION * 1000)
        if (messages.children.length === 0) hide(toastContainer)
    }, time * 1000)
}
